<template>
  <div class="hpSpinner" v-show="showSpinner" @click.stop>
    <div class="content">
      <img src="../assets/images/spinner/loading.png" class="rotation"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'hp-spinner',
    props: {
      spinner: {type: Number, default: 0}
    },
    computed: {
      showSpinner() {
        return (this.spinner > 0);
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../styles/hpCommon.scss";
  @import "../styles/hpMixin.scss";
  @import "../styles/hpConstant.scss";

  .hpSpinner {
    @include userSelectNone;
    display: flex;
    align-items: center;
    position: absolute;
    top: 5;
    right: 0;
    bottom: 5;
    left: 0;
    margin: 0 auto;
    z-index: 10;

    .content {
      display: block;
      width: 60px;
      margin: 0 auto;

      .rotation {
        animation: rotation 1s infinite linear;
      }

      @keyframes rotation {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(359deg);
        }
      }
    }
  }
</style>
